import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VChip,_vm._b({attrs:{"color":_vm.getColor(),"text-color":"white","small":""}},'v-chip',_vm.$attrs,false),[(_vm.totalUnitsValue != '~')?_c('span',[_vm._v(_vm._s(_vm.usedUnits)+"/"+_vm._s(_vm.totalUnitsValue))]):_c(VIcon,{attrs:{"small":""}},[_vm._v("mdi-infinity")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }